import axiosInstance from './axios';

export enum ConfigCategory {
  WORK_SCHEDULE = 'WORK_SCHEDULE',
  LEAVE_POLICY = 'LEAVE_POLICY',
  LATE_EARLY_POLICY = 'LATE_EARLY_POLICY',
  APPROVAL_POLICY = 'APPROVAL_POLICY',
  NOTIFICATION = 'NOTIFICATION',
  SYSTEM = 'SYSTEM',
}

export enum ConfigDataType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  JSON = 'JSON',
}

export interface SystemConfig {
  id: number;
  configKey: string;
  configValue: string;
  dataType: ConfigDataType;
  category: ConfigCategory | null;
  description: string | null;
  isEditable: boolean;
  updatedBy: number | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateConfigDto {
  configKey: string;
  configValue: string;
  dataType: ConfigDataType;
  category?: ConfigCategory;
  description?: string;
  isEditable?: boolean;
}

export interface UpdateConfigDto {
  configValue?: string;
  category?: ConfigCategory;
  description?: string;
  isEditable?: boolean;
}

export interface ConfigsListResponse {
  items: SystemConfig[];
  page: number;
  pageSize: number;
  total: number;
}

class ConfigsService {
  async getAll(params?: {
    page?: number;
    pageSize?: number;
    category?: ConfigCategory;
    q?: string;
  }): Promise<ConfigsListResponse> {
    const response = await axiosInstance.get<ConfigsListResponse>('/configs', { params });
    return response.data;
  }

  async getByCategory(category: ConfigCategory): Promise<Record<string, any>> {
    const response = await axiosInstance.get<Record<string, any>>(`/configs/category/${category}`);
    return response.data;
  }

  async getWorkSchedule(): Promise<Record<string, any>> {
    const response = await axiosInstance.get<Record<string, any>>('/configs/work-schedule');
    return response.data;
  }

  async getByKey(key: string): Promise<SystemConfig> {
    const response = await axiosInstance.get<SystemConfig>(`/configs/${key}`);
    return response.data;
  }

  async create(data: CreateConfigDto): Promise<SystemConfig> {
    const response = await axiosInstance.post<SystemConfig>('/configs', data);
    return response.data;
  }

  async update(key: string, data: UpdateConfigDto): Promise<SystemConfig> {
    const response = await axiosInstance.patch<SystemConfig>(`/configs/${key}`, data);
    return response.data;
  }

  async updateValue(key: string, value: any): Promise<SystemConfig> {
    const response = await axiosInstance.patch<SystemConfig>(`/configs/${key}/value`, { value });
    return response.data;
  }

  async delete(key: string): Promise<void> {
    await axiosInstance.delete(`/configs/${key}`);
  }
}

export const configsService = new ConfigsService();
